<template lang="html">
  <div id="floorplans_list_table" class="w-100 ph4 pb4 overflow-y-auto">
    <table class="collapse w-100 mw8 center">
      <tr class="pa1 ttu mid-gray ff2 f6 tl tracked">
        <th class="pv2"></th>
        <th class="pv2 pointer hover-action user-select-none" @click="sortBy('name')">
          <div class="flex items-center">
            <span>name</span>
            <i class="material-icons" v-if='sortKey === "name" && !reverse'>&#xE5C5;</i>
            <i class="material-icons" v-else-if='sortKey === "name" && reverse'>&#xE5C7;</i>
            <i class="material-icons f6 ml1 moon-gray" v-else>&#xE164;</i>
          </div>
        </th>
        <th class="pv2 pointer hover-action user-select-none" @click="sortBy('type.slug')">
          <div class="flex items-center">
            <span>type</span>
            <i class="material-icons" v-if='sortKey === "type.slug" && !reverse'>&#xE5C5;</i>
            <i class="material-icons" v-else-if='sortKey === "type.slug" && reverse'>&#xE5C7;</i>
            <i class="material-icons f6 ml1 moon-gray" v-else>&#xE164;</i>
          </div>
        </th>
        <th class="pv2 pointer hover-action user-select-none" @click="sortBy('baths')">
          <div class="flex items-center">
            <span>bath</span>
            <i class="material-icons" v-if='sortKey === "baths" && !reverse'>&#xE5C5;</i>
            <i class="material-icons" v-else-if='sortKey === "baths" && reverse'>&#xE5C7;</i>
            <i class="material-icons f6 ml1 moon-gray" v-else>&#xE164;</i>
          </div>
        </th>
        <th class="pv2 pointer hover-action user-select-none" @click="sortBy('stacks[0].view[0]')">
          <div class="flex items-center">
            <span>view</span>
            <i class="material-icons" v-if='sortKey === "stacks[0].view[0]" && !reverse'>&#xE5C5;</i>
            <i class="material-icons" v-else-if='sortKey === "stacks[0].view[0]" && reverse'>&#xE5C7;</i>
            <i class="material-icons f6 ml1 moon-gray" v-else>&#xE164;</i>
          </div>
        </th>
        <th class="pv2 pointer hover-action user-select-none" @click="sortBy('interior')">
          <div class="flex items-center">
            <span>sqft</span>
            <i class="material-icons" v-if='sortKey === "interior" && !reverse'>&#xE5C5;</i>
            <i class="material-icons" v-else-if='sortKey === "interior" && reverse'>&#xE5C7;</i>
            <i class="material-icons f6 ml1 moon-gray" v-else>&#xE164;</i>
          </div>
        </th>
        <th class="pv2"></th>
      </tr>
      <transition-group name="row-animate" class="f5 f6-m tl relative" tag="tbody">
        <router-link tag="tr"
          v-for="(plan, index) in currentPlanList"
          :key="plan.id"
          :to="{ name: 'FloorplanDetail', params: { id: plan.id }}"
          class="row-animate-item hover-bg-light-gray b pointer hover-action bb"
          :class="{ 'bg-highlight': index % 2 === 0 }"
        >
          <td class="pv2 ph2 favourite">
            <i class="material-icons interact-favourite pointer" :class="{'invisible': favourites.length >= maxFavourites}" v-if="!plan.favourited" @click.stop="TOGGLE_FAVOURITE_PLAN(plan.id)">&#xE83A;</i>
            <i class="material-icons interact-favourite pointer" v-else @click.stop="TOGGLE_FAVOURITE_PLAN(plan.id)">&#xE838;</i>
          </td>
          <td class="font-futura-bold pv2 ttc" v-html="plan.name"></td>
          <td class="font-futura-bold pv2">{{ plan.type.shortLabel }}</td>
          <td class="font-futura-bold pv2">{{ plan.baths }}</td>
          <td class="font-futura-bold pv2 ttu">{{ plan.stacks[0].view[0] }}</td>
          <td class="font-futura-bold pv2">{{ plan.interior }}</td>
          <td class="pv2">
            <v-link
              label="DETAILS"
              icon-code="keyboard_arrow_right"
              icon-pos="right"
              icon-class="f5 b"
              class="bg-transparent f7 tracked"
              :route="{ name: 'FloorplanDetail', params: { id: plan.id }}"
            />
          </td>
        </router-link>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import lodash from 'lodash';
import LinkComponent from '@/components/Link';
import FloorplanMixin from '../FloorplanMixin';

export default {
  data() {
    return {
      listEnabled: false,
      sortKey: 'name',
      reverse: false
    };
  },
  mixins: [FloorplanMixin],
  components: {
    'v-link': LinkComponent
  },
  computed: {
    ...mapGetters([
      'activeFloorplans',
      'filtersTypes',
      'favourites',
      'favouritesMode',
      'maxFavourites'
    ]),
    currentPlanList() {
      const plans = (this.favouritesMode) ? this.favourites : this.activeFloorplans;
      let ascDesc = 'asc';
      if (!this.reverse) {
        ascDesc = 'desc';
      }
      const sorted = lodash.orderBy(plans, this.sortKey, ascDesc);
      return sorted;
    }
  },
  methods: {
    ...mapActions([
      'TOGGLE_FAVOURITE_PLAN',
      'TOGGLE_VIEWING_FAVOURITES'
    ]),
    closeFavourites() {
      if (this.favouritesMode) {
        this.TOGGLE_VIEWING_FAVOURITES();
      }
    },
    sortBy(column) {
      this.reverse = (this.sortKey === column) ? !this.reverse : false;
      this.sortKey = column;
    }
  }
};
</script>

<style lang="scss">
.row-animate-item {
  transition: all 0.5s;

  &:hover {
    transition: all 0.1s;
  }
}

td.favourite i {
  visibility: visible;
  &.invisible { visibility: hidden; }
}

.row-animate-enter, .row-animate-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.row-animate-leave-active {
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanList/FloorplanListTable.vue